/**
 * Field helper utilities for QuoteRequestDetail
 */

/**
 * Get human-readable label for a field
 */
export const getFieldLabel = (field) => {
  const labels = {
    vendor_id: 'Vendor',
    condition: 'Condition',
    certification_id: 'Certification',
    price_unit: 'Unit Price',
    lead_time: 'Lead Time in Days',
    currency_id: 'Currency',
    product_uom_id: 'Unit of Measure'
  };
  return labels[field] || field;
};

/**
 * Get formatted display value for a cell
 */
export const getCellValue = (line, field) => {
  switch (field) {
    case 'vendor_id':
      return line.vendor_name || 'No vendor selected';
    case 'condition':
      return line.condition || 'No condition set';
    case 'certification_id':
      return line.certification_name || 'No certification set';
    case 'price_unit':
      return line.price_unit ? `$${parseFloat(line.price_unit).toFixed(2)}` : 'No price set';
    case 'lead_time':
      return line.lead_time ? `${line.lead_time} days` : 'No lead time set';
    case 'currency_id':
      return line.currency_name || 'USD';
    case 'product_uom_id':
      return line.product_uom_name || 'No UoM set';
    default:
      return line[field] || 'Empty';
  }
};

/**
 * Get accessible description for a row
 */
export const getRowDescription = (line, lineIndex) => {
  return `Row ${lineIndex + 1}, Part ${line.name || 'Unknown'}, ${line.product_name || 'No description'}, Quantity ${line.product_qty || 1}, Status ${line.state_display || line.state}`;
};

/**
 * Find certification ID by name from options
 */
export const getCertificationIdByName = (certificationOptions, name) => {
  const cert = certificationOptions.find(c => c.label === name || c.label.includes(name));
  return cert ? cert.value : null;
};

/**
 * Editable fields for keyboard navigation
 */
export const EDITABLE_FIELDS = ['vendor_id', 'condition', 'certification_id', 'price_unit', 'lead_time'];
